define('error-handler',['loader', 'jquery', 'angular', 'vspot-services'], function (loader, $, ng) {
    'use strict';

    var error = ng.module('error-handler', ['vspot.services']);

    /*
     *  Intercepts all client side errors. The last line of defense.
     *  Logs the error to the server and opens up a generic error
     *  recovery dialog to the user.
     *
     *  Should generally be used when an error has occurred, and we
     *  have no idea what to do about it, and have no useful feedback
     *  to give to the user.
     */
    error.factory('$exceptionHandler', ['$log', 'services.PageUnload', function ($log, PageUnload) {
        return function (exception, cause) {
            // make sure the page isn't unloading before deciding to show an error
            if (!PageUnload.wasCalled()) {

                // PWD: turns out exception may be an array. if so, pick off the first element
                if (Array.isArray(exception)) {
                    exception = exception[0];
                }

                if (exception.message !== '0') {        // I believe timeout exceptions have a message of 0
                    global_helper.client_logger({
                        error_message: exception.message,
                        error_file: window.location.href,
                        error_line: exception.stack
                    }, 'javascript');
                    global_helper.open_error_dialog({
                        error_message: exception.message,
                        error_file: window.location.href,
                        error_line: exception.stack
                    });
                    $log.info(exception.stack);
                }
            }
        };
    }]);

    /*
     *  Intercepts all $http and $resource calls. If an error occurs,
     *  it logs the error to the server and opens up a generic error
     *  recovery dialog to the user.
     *
     *  A.M. Modified return value to reflect newer (now required) format.
     */
    error.factory('httpErrorInterceptor', ['$q', 'services.PageUnload', '$log', function ($q, PageUnload, $log) {
        return {
            response: function(response) {
                return response;
            },
            responseError: function(response) {
                if (response.status === 409) {
                    // user tried to submit a form twice. the first one is going through, so no need to show an error
                } else if (response.status === 403) {
                    $log.log("httpErrorInterceptor redirecting", response);
                    var triggerUri = 'undefined';
                    if( response && response.config && response.config.url ) {
                        triggerUri = response.config.url;
                    }
                    if (response.data.message === 'Authentication failed') {
                        // user is no longer logged in; redirect to login page
                        window.location = '/login/signin?triggerUri=' + encodeURIComponent(triggerUri);
                    } else {
                        // user has attempted to access an area they don't have authorization for,
                        // likely logged in as a different user
                        window.location = '/Dashboard?error=true&errorType=' + encodeURIComponent(response.data.message) + '&triggerUri=' + encodeURIComponent(triggerUri);
                    }
                } else if (response.status > 0) {
                    var url;

                    if (response.config) {
                        url = response.config.url;
                    } else {
                        url = '';
                    }

                    // make sure the page isn't unloading before deciding to show an error
                    if (!PageUnload.wasCalled()) {
                        global_helper.client_logger({
                            error_message: response.statusText,
                            error_file: url,
                            error_line: -1
                        }, response.status);
                        global_helper.open_error_dialog({error_message: response.statusText, error_file: url});
                    }
                } else {
                    // make sure the page isn't unloading before deciding to show an error
                    if (!PageUnload.wasCalled()) {
                        // status of 0 can be meaningful, so we don't want to ignore it.
                        // but, it can also mean interrupted by a page unload, so wait and see which one it is
                        setTimeout(function () {
                            global_helper.client_logger({
                                error_message: response.statusText,
                                error_file: url,
                                error_line: -1
                            }, response.status);
                            global_helper.open_error_dialog({error_message: response.statusText, error_file: url});
                        }, 5000);
                    }
                }

                return $q.reject(response);
            }
        };
    }]);

    /*
     *  A service that logs an error to the server. This is for
     *  when we do have useful feedback to give to the user,
     *  but it was still an error that should not have occurred.
     */
    error.factory('ErrorLogger', function () {
        return function (message, file, lineNumber, errorType) {
            var errType;
            // default to client error
            if (!errorType) {
                errType = 'client';
            } else {
                errType = errorType;
            }

            global_helper.client_logger({
                error_message:  message,
                error_file:     file,
                error_line:     lineNumber
            }, errType);
        };
    });

    error.config(['$provide', '$httpProvider', function($provide, $httpProvider) {
        // push function to the interceptors which will intercept
        // the http responses of the whole application
        $httpProvider.interceptors.push('httpErrorInterceptor');
    }]);
});

